import { Component, inject } from '@angular/core'
import { AsyncPipe } from '@angular/common'
import { FooterComponent } from '../../ui/footer/footer.component'
import { Router, RouterOutlet } from '@angular/router'
import { HeaderComponent } from '../../ui/header/header.component'
import { AuthService } from '../../../shared/services/auth.service'
import { Observable } from 'rxjs'
import { User } from '../../../shared/models/user'
import { UserDomain } from '../../../shared/domain/user.domain'
import { Chantier } from '../../../shared/models/chantier'
import { HomeDomain } from '../../../home/domain/home.domain'
import { CoreDomainService } from '../../../core/domain/core.domain'
import { EvenementDomainService } from '../../../shared/domain/evenement.domain'

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss'],
  imports: [HeaderComponent, RouterOutlet, FooterComponent, AsyncPipe],
})
export class AppLayoutComponent {
  protected readonly logoHeuresInsertionUrl = 'assets/images/logos/HEURE_INSERTION_LOGO.png'
  protected readonly logoFooterUrl = 'assets/images/logos/logo-lg-gray.png'
  protected readonly connectedUser$: Observable<User>
  protected readonly selectableUserChantiers$: Observable<Chantier[]>
  protected readonly selectedChantier$: Observable<Chantier>
  protected readonly backendVersion$: Observable<string>
  private readonly authService = inject(AuthService)
  private readonly userDomain = inject(UserDomain)
  private readonly chantierDomain = inject(HomeDomain)
  private readonly router = inject(Router)
  private readonly coreDomainService = inject(CoreDomainService)
  private readonly evenementDomainService = inject(EvenementDomainService)


  constructor() {
    this.connectedUser$ = this.userDomain.connectedUser$
    this.selectableUserChantiers$ = this.userDomain.selectableUserChantiers$
    this.selectedChantier$ = this.chantierDomain.selectedChantier$
    this.backendVersion$ = this.coreDomainService.getVersionBackend()
  }

  logOut(): void {
    this.authService.logOut()
  }

  onChantierSelected(chantierCode: string): void {
    this.router.navigate(['chantiers', chantierCode])
    if (chantierCode) {
      this.evenementDomainService.createSelectionChantierEvenement(chantierCode).subscribe()
    }
  }
}
